// Library
import googleMapsApiLoader from 'google-maps-api-loader'
// Config
import { apiKey } from './config'
// Utils
import { isNil } from 'lodash'

// Librerías que SIEMPRE necesita la app (autocomplete -> "places",
// mapas de calor -> "visualization"). Se fijan aquí para que la
// carga sea consistente sin importar qué componente la dispare.
const DEFAULT_LIBRARIES = ['places', 'visualization']

// Cacheamos la PROMESA (no el resultado) para que varias llamadas
// concurrentes compartan una única carga del script y evitar inyectar
// el <script> de Google Maps más de una vez (causa de los errores
// intermitentes "...included the Google Maps JavaScript API multiple
// times" y "google.maps.places is undefined" en algunos navegadores).
let googleMapAPIPromise = null

/**
 * Carga las librerías de Google Maps (idempotente: una sola carga real
 * aunque se invoque desde varios componentes a la vez).
 *
 * @param {Object} params - parámetros opcionales de carga
 * @return {Promise<Object>}
 */
export function loadGoogleMap(params = {}) {
  if (isNil(googleMapAPIPromise)) {
    googleMapAPIPromise = googleMapsApiLoader({
      apiKey,
      libraries: DEFAULT_LIBRARIES,
      ...params
    }).catch((error) => {
      // Si falla, limpiamos la caché para permitir un reintento posterior
      googleMapAPIPromise = null
      throw error
    })
  }
  return googleMapAPIPromise
}
